import React, { useState, useEffect, useCallback } from 'react'
import { useValues, useActions } from 'kea'
import Modal from 'react-responsive-modal'
import { useMediaQuery } from 'react-responsive'
import { useSelector } from 'react-redux'
import { hot } from 'react-hot-loader'
import PropTypes from 'prop-types'

import railsContext from 'lib/selectors/rails-context'
import TranslateToggle from 'lib/i18n/translate-toggle'

import ProfilePhoto from '~/scenes/shared/avatar/profile-photo'
import createAvatarLogic from '~/scenes/shared/avatar/logic'

import logic from './logic'

import router from './router'

const MAX_EXTRA_SMALL_WIDTH = 480
const MAX_SMALL_WIDTH = 691
const MIN_MEDIUM_WIDTH = 692
const MAX_MEDIUM_WIDTH = 1007
const MIN_LARGE_WIDTH = 1008

const sharedAvatarLogic = createAvatarLogic({ logic, NoAvatar: true })

function ProfilePhotoWrapper ({ actions, ...props }) {
  return <ProfilePhoto {...props} {...actions} withIconsUi />
}

const ConnectedProfilePhotoModal = sharedAvatarLogic(ProfilePhotoWrapper)

function App ({ children }) {
  const [hidden, setHidden] = useState(false)
  const { isTeacher, hasAvatar } = useSelector(railsContext)
  const { isCloseModal } = useValues(logic)
  const { closeModal } = useActions(logic)
  const { scene } = useValues(router)

  const isExtraMobileView = useMediaQuery({ maxWidth: MAX_EXTRA_SMALL_WIDTH })
  const isMobileView = useMediaQuery({ maxWidth: MAX_SMALL_WIDTH })
  const isTabletView = useMediaQuery({ minWidth: MIN_MEDIUM_WIDTH, maxWidth: MAX_MEDIUM_WIDTH })
  const isDesktopView = useMediaQuery({ minWidth: MIN_LARGE_WIDTH })

  // This function updates all the i18n
  const update = useCallback(() => {
    setHidden(true)
  }, [setHidden])

  useEffect(() => {
    if (hidden) {
      setHidden(false)
    }
  }, [hidden, setHidden])

  return (
    <div>
      {hidden ? null : children}
      <TranslateToggle update={update} />
      {typeof window !== 'undefined' && (
        <Modal
          closeOnOverlayClick={true}
          showCloseIcon={false}
          open={
            (!isCloseModal && isTeacher && !hasAvatar) ||
            (!isCloseModal && scene === 'courseEdit' && !isTeacher && !hasAvatar)
          }
          onClose={() => {}}
          center
          classNames={{
            overlay: `${isExtraMobileView && hasAvatar ? 'customOverlay' : ''}${
              isMobileView && !hasAvatar ? 'custom-overlay-profile-photo' : ''
            }${!isMobileView && !isExtraMobileView && !hasAvatar ? 'custom-overlay-md-lg' : ''}
            }`,
            modal: `${isDesktopView && !hasAvatar ? 'profile-photo-modal' : ''}${
              isMobileView && !hasAvatar ? 'mobile-profile-photo-modal' : ''
            }${isTabletView && !hasAvatar ? 'tablet-profile-photo-modal' : ''}`
          }}
        >
          <ConnectedProfilePhotoModal closeModal={closeModal} />
        </Modal>
      )}
    </div>
  )
}

ProfilePhotoWrapper.propTypes = {
  actions: PropTypes.object
}

App.propTypes = {
  children: PropTypes.node
}

export default hot(module)(App)
